import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NvButtonModule } from 'Src/nvps-libraries/design/nv-button/nv-button.module';
import { NvFormFieldModule } from 'Src/nvps-libraries/design/nv-form-field/nv-form-field.module';
import { NvLogoModule } from 'Src/nvps-libraries/design/nv-logo/nv-logo.module';
import { NvTextboxModule } from 'Src/nvps-libraries/design/nv-textbox/nv-textbox.module';
import { PartnerPickerComponent } from './partner-picker.component';
import { PartnerPickerDataService } from './partner-picker.data.service';

@NgModule({
  imports: [CommonModule, NvButtonModule, NvFormFieldModule, NvLogoModule, NvTextboxModule],
  providers: [PartnerPickerDataService],
  declarations: [PartnerPickerComponent],
})
export class PartnerPickerModule {}
